import Icon from 'components/icon';
import { useMenu } from 'context/MenuContext';
import { useEffect, useState } from 'react';
import formatIdentifier from 'utils/formatIdentifier';
import { getCompanyId, getCurrentIdentifier } from 'utils/identifier';
import { getPreferredLanguage } from 'utils/preferredLanguage';
import limitStringLength from 'utils/utils';
import ProfileSettings from './settings';
import styles from './styles.module.scss';
import { getCurrentProduct } from 'utils/productCookies';
import TagManager from 'react-gtm-module';

function Profile() : JSX.Element {
  const [isVisible, changeVisibility] = useState(false);
  const {
    menu,
    companies,
    isUndefined,
    fetchCompanies
  } = useMenu();

  const currentIdentifier = getCurrentIdentifier();
  const toogleSettings = () : void => {
    let timeoutTime = 0;

    if (isUndefined()) {
      fetchCompanies();
      timeoutTime = 2000;
    }

    setTimeout(() => {
      if(isUndefined())
        return;

      changeVisibility(!isVisible);
    }, timeoutTime);
  };

  const getCurrentCompanyName = () : string => {
    if(companies.length == 0)
      return '';

    const currentCompany = companies.filter(x => x.identifier === currentIdentifier);
    if(currentCompany.length === 0)
      return '';

    if(currentCompany.length === 1)
      return limitStringLength(currentCompany[0].name, 13);

    const cookieCompanyId = getCompanyId();

    const companyWithGroup = currentCompany.filter(x => {
      if(!x.companyId)
        return;

      return x.companyId.some(y => y.id === cookieCompanyId && y.noun === getCurrentProduct());
    })[0];

    if(!companyWithGroup)
      return limitStringLength(currentCompany[0].name, 13);

    return limitStringLength(companyWithGroup.name, 13);
  };

  const getCompanyLetters = () : string => {
    const name = getCurrentCompanyName();
    const firstLetter = name.substring(0,1);
    const spaceIndex = name.indexOf(' ');

    if (spaceIndex === -1)
      return firstLetter;

    return `${firstLetter}${name.substring(spaceIndex + 1, spaceIndex + 2)}`;
  };


  useEffect(() => {
    if(Object.keys(companies).length === 0) return;
    if (Object.keys(menu).length === 0) return;

    const tagManagerArgs = {
      gtmId: 'GTM-TSFKGV3',
      dataLayer: {
        email: menu.email,
        fullname: menu.fullName,
        companyId: getCompanyId(),
        companyName: getCurrentCompanyName(),
        identifier: getCurrentIdentifier()
      },
    };

    TagManager.initialize(tagManagerArgs);
  }, [companies, menu]);

  return (
    <div id='biobar-profile' className={styles['biobar-profile']}>
      <button id={styles['biobar-profile-button']} onClick={toogleSettings}>
        <div id={styles['biobar-company-letters']}>
          <p>{getCompanyLetters()}</p>
        </div>
        <div id={styles['biobar-names']}>
          <p>{ getCurrentCompanyName() }</p>
          <p>{ limitStringLength(formatIdentifier(getCurrentIdentifier(), getPreferredLanguage()), 18) }</p>
        </div>
        <Icon
          iconName={isVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }
          className={styles['biobar-icon']} />
      </button>
      { isVisible ? <ProfileSettings toogleSettings={toogleSettings} /> : <></> }
    </div>
  );
}

export default Profile;